import { Vue, Component, Watch } from 'vue-property-decorator';
import Mask from './popup.vue';

@Component
export default class TPopupMixin extends Vue {
  private static zIndexStack: Array<any> = [];

  private static Popup: any = null;

  private static instances: Array<any> = [];

  private static count: number = 1;

  private id: number = 0;

  public show?: boolean;

  public isTop: boolean = false;

  created() {
    if (!TPopupMixin.Popup) {
      TPopupMixin.Popup = new Mask({
        el: document.createElement('div'),
        data: {
          show: this.show || false,
        },
      });
      TPopupMixin.Popup.escKeyDown = () => {
        const current = TPopupMixin.zIndexStack[TPopupMixin.zIndexStack.length - 1];
        if (current && current.handleEscModel) current.$emit('beforeClose', 'dialog');
      };
      document.body.appendChild(TPopupMixin.Popup.$el);
    }
    /* eslint-disable no-plusplus */
    this.id = ++TPopupMixin.count;
    TPopupMixin.Popup.show = true;
    TPopupMixin.instances.push(this);
  }

  // 处理叠堆问题
  setStack() {
    if (this.show) {
      this.isTop = true;
      TPopupMixin.zIndexStack.push(this);
      if (TPopupMixin.zIndexStack.length > 1) {
        TPopupMixin.zIndexStack[TPopupMixin.zIndexStack.length - 2].isTop = false;
      }
    } else {
      const instance = TPopupMixin.zIndexStack.pop();
      if (instance) instance.isTop = false;
      if (TPopupMixin.zIndexStack.length > 0) {
        TPopupMixin.zIndexStack[TPopupMixin.zIndexStack.length - 1].isTop = true;
      } else TPopupMixin.Popup.show = false;
    }
  }

  mounted() {
    if (TPopupMixin.Popup) TPopupMixin.Popup.$el.appendChild(this.$el);
    this.setStack();
  }

  @Watch('show')
  watcShow() {
    this.setStack();
  }

  destroyed() {
    this.$emit('beforeClose', 'dialog');
    TPopupMixin.instances = TPopupMixin.instances.filter((em: any) => this.id !== em.id);
    /* eslint-disable no-unused-expressions */
    if (TPopupMixin.instances.length === 0) {
      TPopupMixin.Popup && TPopupMixin.Popup.$destroy();
      TPopupMixin.Popup = null;
    }
  }
}
